<!-- <router-outlet></router-outlet>
<ngu-alert-main></ngu-alert-main> -->

<div class="app-conainer">
    <div class="app-conainer-shell">
      <alert-notification></alert-notification>
      <router-outlet></router-outlet>
    </div>
</div>  